import { CreditReport } from "types/landlord/reports";
import { Section } from "views/applications-id-report/components/Section";

interface CreditInquiriesProps {
  credit_inquiries?: CreditReport["credit_inquiries"];
  isNoHit: boolean;
}

export const CreditInquiries = ({
  credit_inquiries,
  isNoHit
}: CreditInquiriesProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Credit inquiries" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Credit inquiries" maxWidth="none">
      <div className="flex justify-between gap-2 border-b border-alpha-40 pb-3.5 text-sm font-medium text-content-300">
        <p>Inquirer</p>
        <p>Date</p>
      </div>
      {credit_inquiries?.map((inquiry) => {
        return (
          <div
            className="flex h-12 items-center justify-between gap-2 border-b border-alpha-40 py-3.5 text-sm font-medium text-content-1000"
            key={`${inquiry.inquirer}_${inquiry.date}`}
          >
            <p>{inquiry.inquirer}</p>
            <p>{inquiry.date}</p>
          </div>
        );
      })}
    </Section>
  );
};
